// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html body {
  height: 100%;
  position: fixed;
  width: 100%;
}
body {
  margin: 0px;
  background-color: #1a1a1a;
  font-family: 'Lato', sans-serif;
  font-weight: 300;
}
* {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
}
#app {
  position: relative;
}
.page {
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  background-color: #1a1a1a;
}
.top {
  display: flex;
  height: 80px;
  align-self: stretch;
  justify-content: center;
  font-family: 'Lato', sans-serif;
  font-weight: 100;
  font-size: 18px;
  color: #555;
  position: fixed;
  background-color: #fbf7f5;
  z-index: 50;
  flex: 1;
}
.topMid {
  display: flex;
  flex-direction: row;
  height: 63px;
  align-items: flex-end;
  justify-content: space-between;
}
.bottom {
  height: 130px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-self: stretch;
  background-color: blue;
}
.mid {
  font-family: 'Lato', sans-serif;
  font-weight: 100;
  font-size: 18px;
  color: #555;
  text-align: center;
}

.footer {
  bottom: 0;
  width: 100%;
  height: 70px;
  align-self: stretch;
  /* background-color: red; */
  position: absolute;
}
.checkout {
  width: 200px;
  align-self: flex-end;
}

.summary {
  width: 400px;
  display: flex;
  flex-direction: column;
  font-family: 'Lato', sans-serif;
  font-weight: 100;
  font-size: 18px;
  color: #555;
}

.main {
  display: flex;
  padding-top: 80px;
  margin-bottom: 100px;
}

.sideBarText {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
  color: #fff;
  font-size: 24px;
}

.navBar {
  transition: all 0.2s ease;
}
.navBarOp {
  transition: all 0.4s ease;
}
.barTemple {
  transform: translateX(92px);
}
.barChat {
  transform: translateX(172px);
}

/* mobileMenu */
.timesLeft {
  transform: rotate(-45deg);
}
.timesRight {
  transform: rotate(45deg);
}

.boxShadow {
  transition: all 0.01s ease-in-out;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.06);
}
.boxShadow:hover {
  transition: all 0.01s ease-in-out;
  box-shadow: 1px 2px 3.5px rgba(0, 0, 0, 0.38);
}
.boxShadowW {
  transition: all 0.01s ease-in-out;
  box-shadow: 0px 1px 8px rgba(151, 151, 151, 0.36);
}

/*anim */
.slideDown {
  animation: 0.3s slideDownA ease;
}
@keyframes slideDownA {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(100px);
  }
}
.enterUp {
  animation: 0.6s enterUpA ease;
}
@keyframes enterUpA {
  0% {
    opacity: 0;
    transform: translateY(32%);
  }
  20% {
    opacity: 0.1;
  }
  50% {
    opacity: 0.8;
    transform: translateY(0%);
  }
  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}

/* botbar */
.botPlus {
  background-color: #fbf7f5;
  border: 1px solid #888;
}

.botPlus:hover {
  background-color: #888;
  color: #fbf7f5;
  border: 1px solid #888;
}
/*setup*/
.blurRow {
  transition: opacity 250ms ease;
}

/* pfp */
.pfpBox {
  transition: all 200ms ease;
  height: 160px;
  width: 160px;
  margin-bottom: 10px;
  /*background-color: #fbf7f5;*/
  /*background-color: blue; */
  border-radius: 10px;
  overflow: hidden;
  cursor: pointer;
  opacity: 0.8;
}
.pfpBox:hover {
  transition: all 200ms ease;
  margin-top: -3px;
  opacity: 1;
}

.pfpFade {
  animation: 0.6s pfpFadeA ease;
}
@keyframes pfpFadeA {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 0.8;
  }
}

.blur {
  filter: blur(4px);
  opacity: 0.8;
}

.mainList {
  display: flex;
  flex-direction: column;
  transition: all 200ms ease;
}

/* add */
input.addText::placeholder {
  color: #fff;
  opacity: 0.2;
  margin-right: -3px;
}

input.newInput::placeholder {
  color: #bbb;
  font-size: 20px;
}

/* setup */
.textInput:placeholder {
  color: #888;
}
textarea:focus,
input:focus {
  outline: none;
}

.card {
  background-color: #111;
  width: 115px;
  height: 160.7px;
  border-radius: 6px;
  border: 1px solid #555;
  margin-top: -143px;
  transition: margin-top 0.3s ease; /* Smooth transition for the margin-top change */
}

.card:first-child {
  margin-top: 0; /* Ensure the first card doesn't overlap */
}

.card:hover + .card {
  margin-top: 0; /* Reset marginTop for the card immediately following a hovered card */
}

.floppy {
  transition: all 0.01s ease-in-out;
  opacity: 0.5;
}
.floppy:hover {
  transition: all 0.01s ease-in-out;
  opacity: 1;
}

.plate {
  line-height: 1;
  overflow: scroll;
}
.plate:focus {
  outline: none;
}

.flexCol {
  display: flex;
  flex-direction: column;
}
.flexRow {
  display: flex;
  flex-direction: row;
}
.flexCenter {
  display: flex;
  align-items: center;
  justify-content: center;
}

/*temples*/
.slideRow {
}

.decks {
  display: flex;
  flex-direction: column-reverse; /* This makes the first item appear at the bottom */
  align-items: start; /* Align items to the start of the flex-container */
  overflow-y: auto; /* Allows scrolling when items exceed the container height */
}

/*chats */
.raw::-webkit-scrollbar {
  display: none;
}
.rawList::-webkit-scrollbar {
  display: none;
}
.dmChat::-webkit-scrollbar {
  display: none;
}

/* fonts */
.lato300 {
  font-family: 'Lato', sans-serif;
  font-weight: 300;
}
.lato400 {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
}
.lato700 {
  font-family: 'Lato', sans-serif;
  font-weight: 700;
}
.lora500 {
  font-family: 'Lora', serif;
  font-weight: 500;
}

.introButton {
  border: 1px solid #555;
  cursor: pointer;
}
.introButtonText {
  border: 1px solid #555;
}

.introButton:hover {
  background-color: #3c3c9c;
  border-color: #3c3c9c;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type='number'] {
  -moz-appearance: textfield;
}

/*inputs */
input {
  box-sizing: border-box;
  -webkit-appearance: none;
  appearance: none;
}
input:focus {
  outline: none; /* remove default outline */
  border-color: #888; /* or add a custom focus style */
}

/* button */
button {
  background: transparent;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
}

button:hover {
  cursor: pointer;
  background: transparent;
  box-shadow: 0px 0px 0px transparent;
  border: 0px solid transparent;
  text-shadow: 0px 0px 0px transparent;
}

button:active {
  outline: none;
  border: none;
}

button:focus {
  outline: 0;
}

.hidden {
  display: none;
}

.pointer {
  cursor: pointer;
}

.hideScroll {
  -ms-overflow-style: none; /* Internet Explorer 10+ */
  scrollbar-width: none; /* Firefox */
}

.hideScroll::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
}

/* Super-thin, gray-on-black scrollbars (still scrollable, barely visible) */
.thinScroll,
.thinScroll * {
  scrollbar-width: thin; /* Firefox */
  scrollbar-color: #3a3a3a transparent; /* thumb, track */
}

.thinScroll::-webkit-scrollbar,
.thinScroll *::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

.thinScroll::-webkit-scrollbar-track,
.thinScroll *::-webkit-scrollbar-track {
  background: transparent;
}

.thinScroll::-webkit-scrollbar-thumb,
.thinScroll *::-webkit-scrollbar-thumb {
  background: #3a3a3a;
  border-radius: 3px;
}

.thinScroll::-webkit-scrollbar-thumb:hover,
.thinScroll *::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Small inline loading spinner (e.g. Import button) */
@keyframes blogSpin {
  to {
    transform: rotate(360deg);
  }
}

.blogSpinner {
  display: inline-block;
  width: 12px;
  height: 12px;
  border: 2px solid rgba(255, 255, 255, 0.4);
  border-top-color: #fff;
  border-radius: 50%;
  animation: blogSpin 0.6s linear infinite;
}

/* Reusable light-blue hover for the tier-list/deck buttons (inline-styled, so !important on hover). */
.blueHover {
  transition: color 0.18s ease, border-color 0.18s ease;
}
.blueHover:hover:not(:disabled) {
  color: #8fc8ff !important;
  border-color: #8fc8ff !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  -webkit-tap-highlight-color: transparent;
}

/*loader */
@keyframes rotateA {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes rotateA {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotateA {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(360deg);
  }
}
@-o-keyframes rotateA {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(180deg);
  }
}
@-ms-keyframes rotateA {
  from {
    -ms-transform: rotate(0deg);
  }
  to {
    -ms-transform: rotate(360deg);
  }
}
.arc-hider {
  margin-left: 6px;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  border: 2px solid #a6f1df;
  position: absolute;
  z-index: 5;
  clip: rect(0px 18px 18px 0px);
  -webkit-animation: rotateA 2s linear infinite 0s;
  -moz-animation: rotateA 2s linear infinite 0s;
  -o-animation: rotateA 2s linear infinite 0s;
  -ms-animation: rotateA 2s linear infinite 0s;
  animation: rotateA 2s linear infinite 0s;
}

/*colors

pastel orange #ff9b1a

*/

/* timer */
.timer {
  background-color: #aaa;
  position: relative;
}

.bar {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  background-color: #eee;
  width: 100%;
  animation: shrink 5s linear backwards;
}

@keyframes shrink {
  from {
    width: 0;
  }
  to {
    width: 100%;
  }
}

/* ripples */

.circles {
  height: 40px;
  position: relative;
  width: 40px;
  margin-left: -2px;
  margin-top: -2px;

  > div {
    animation: growAndFade 2s ease-out;
    border: 1px solid #000;
    /* background-color: #eee;*/
    border-radius: 50%;
    height: 100%;
    opacity: 0;
    position: absolute;
    width: 100%;
  }
  .circle1 {
    animation-delay: 0s;
  }
  .circle2 {
    animation-delay: 0.2s;
  }
}

@keyframes growAndFade {
  0% {
    opacity: 0.8;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

/* box */
.rotate45 {
  transform: rotate(45deg);
  z-index: 20;
}

.openDeck {
  &:hover {
    background-color: #3c3c9c;
  }
}

.deleteX {
  &:hover {
    background-color: #3c3c9c;
  }
}

/* Hide scrollbar for set-scroll-container */
.set-scroll-container {
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}
.set-scroll-container::-webkit-scrollbar {
  display: none; /* Chrome/Safari/Webkit */
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,WAAW;EACX,OAAO;AACT;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,4BAA4B;AAC9B;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,iCAAiC;EACjC,iDAAiD;AACnD;;AAEA,QAAQ;AACR;EACE,+BAA+B;AACjC;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;IACZ,yBAAyB;EAC3B;EACA;IACE,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA,WAAW;AACX;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;AACA,QAAQ;AACR;EACE,8BAA8B;AAChC;;AAEA,QAAQ;AACR;EACE,0BAA0B;EAC1B,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,2BAA2B;EAC3B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA,QAAQ;AACR;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,WAAW;AACb;AACA;;EAEE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,gCAAgC,EAAE,gDAAgD;AACpF;;AAEA;EACE,aAAa,EAAE,0CAA0C;AAC3D;;AAEA;EACE,aAAa,EAAE,sEAAsE;AACvF;;AAEA;EACE,iCAAiC;EACjC,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,UAAU;AACV;AACA;;AAEA;EACE,aAAa;EACb,8BAA8B,EAAE,mDAAmD;EACnF,kBAAkB,EAAE,mDAAmD;EACvE,gBAAgB,EAAE,4DAA4D;AAChF;;AAEA,SAAS;AACT;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA,UAAU;AACV;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,+BAA+B;EAC/B,gBAAgB;AAClB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;AACZ;EACE,0BAA0B;AAC5B;;AAEA,UAAU;AACV;EACE,sBAAsB;EACtB,wBAAwB;EACxB,gBAAgB;AAClB;AACA;EACE,aAAa,EAAE,2BAA2B;EAC1C,kBAAkB,EAAE,gCAAgC;AACtD;;AAEA,WAAW;AACX;EACE,uBAAuB;EACvB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,wBAAwB,EAAE,0BAA0B;EACpD,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,aAAa,EAAE,sBAAsB;AACvC;;AAEA,4EAA4E;AAC5E;;EAEE,qBAAqB,EAAE,YAAY;EACnC,oCAAoC,EAAE,iBAAiB;AACzD;;AAEA;;EAEE,UAAU;EACV,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA,sDAAsD;AACtD;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA,sGAAsG;AACtG;EACE,qDAAqD;AACvD;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B,EAAE,eAAe;EAC5C,yBAAyB,EAAE,WAAW;EACtC,wBAAwB,EAAE,mBAAmB;EAC7C,sBAAsB,EAAE,4BAA4B;EACpD,qBAAqB,EAAE,2BAA2B;EAClD,iBAAiB,EAAE;gFAC2D;EAC9E,wCAAwC;AAC1C;;AAEA,UAAU;AACV;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE;IACE,+BAA+B;EACjC;EACA;IACE,iCAAiC;EACnC;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;IACE,8BAA8B;EAChC;AACF;AACA;EACE;IACE,0BAA0B;EAC5B;EACA;IACE,4BAA4B;EAC9B;AACF;AACA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,6BAA6B;EAC/B;AACF;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,gDAAgD;EAChD,6CAA6C;EAC7C,2CAA2C;EAC3C,4CAA4C;EAC5C,wCAAwC;AAC1C;;AAEA;;;;CAIC;;AAED,UAAU;AACV;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE;IACE,QAAQ;EACV;EACA;IACE,WAAW;EACb;AACF;;AAEA,YAAY;;AAEZ;EACE,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;;EAEhB;IACE,kCAAkC;IAClC,sBAAsB;IACtB,2BAA2B;IAC3B,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,WAAW;EACb;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,QAAQ;AACR;EACE,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,4CAA4C;AAC5C;EACE,qBAAqB,EAAE,YAAY;EACnC,wBAAwB,EAAE,WAAW;AACvC;AACA;EACE,aAAa,EAAE,yBAAyB;AAC1C","sourcesContent":["html body {\n  height: 100%;\n  position: fixed;\n  width: 100%;\n}\nbody {\n  margin: 0px;\n  background-color: #1a1a1a;\n  font-family: 'Lato', sans-serif;\n  font-weight: 300;\n}\n* {\n  font-family: 'Lato', sans-serif;\n  font-weight: 300;\n}\n#app {\n  position: relative;\n}\n.page {\n  position: relative;\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  justify-content: flex-start;\n  overflow: hidden;\n  background-color: #1a1a1a;\n}\n.top {\n  display: flex;\n  height: 80px;\n  align-self: stretch;\n  justify-content: center;\n  font-family: 'Lato', sans-serif;\n  font-weight: 100;\n  font-size: 18px;\n  color: #555;\n  position: fixed;\n  background-color: #fbf7f5;\n  z-index: 50;\n  flex: 1;\n}\n.topMid {\n  display: flex;\n  flex-direction: row;\n  height: 63px;\n  align-items: flex-end;\n  justify-content: space-between;\n}\n.bottom {\n  height: 130px;\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-self: stretch;\n  background-color: blue;\n}\n.mid {\n  font-family: 'Lato', sans-serif;\n  font-weight: 100;\n  font-size: 18px;\n  color: #555;\n  text-align: center;\n}\n\n.footer {\n  bottom: 0;\n  width: 100%;\n  height: 70px;\n  align-self: stretch;\n  /* background-color: red; */\n  position: absolute;\n}\n.checkout {\n  width: 200px;\n  align-self: flex-end;\n}\n\n.summary {\n  width: 400px;\n  display: flex;\n  flex-direction: column;\n  font-family: 'Lato', sans-serif;\n  font-weight: 100;\n  font-size: 18px;\n  color: #555;\n}\n\n.main {\n  display: flex;\n  padding-top: 80px;\n  margin-bottom: 100px;\n}\n\n.sideBarText {\n  font-family: 'Lato', sans-serif;\n  font-weight: 300;\n  color: #fff;\n  font-size: 24px;\n}\n\n.navBar {\n  transition: all 0.2s ease;\n}\n.navBarOp {\n  transition: all 0.4s ease;\n}\n.barTemple {\n  transform: translateX(92px);\n}\n.barChat {\n  transform: translateX(172px);\n}\n\n/* mobileMenu */\n.timesLeft {\n  transform: rotate(-45deg);\n}\n.timesRight {\n  transform: rotate(45deg);\n}\n\n.boxShadow {\n  transition: all 0.01s ease-in-out;\n  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.06);\n}\n.boxShadow:hover {\n  transition: all 0.01s ease-in-out;\n  box-shadow: 1px 2px 3.5px rgba(0, 0, 0, 0.38);\n}\n.boxShadowW {\n  transition: all 0.01s ease-in-out;\n  box-shadow: 0px 1px 8px rgba(151, 151, 151, 0.36);\n}\n\n/*anim */\n.slideDown {\n  animation: 0.3s slideDownA ease;\n}\n@keyframes slideDownA {\n  0% {\n    transform: translateY(0px);\n  }\n  100% {\n    transform: translateY(100px);\n  }\n}\n.enterUp {\n  animation: 0.6s enterUpA ease;\n}\n@keyframes enterUpA {\n  0% {\n    opacity: 0;\n    transform: translateY(32%);\n  }\n  20% {\n    opacity: 0.1;\n  }\n  50% {\n    opacity: 0.8;\n    transform: translateY(0%);\n  }\n  100% {\n    opacity: 1;\n    transform: translateY(0%);\n  }\n}\n\n/* botbar */\n.botPlus {\n  background-color: #fbf7f5;\n  border: 1px solid #888;\n}\n\n.botPlus:hover {\n  background-color: #888;\n  color: #fbf7f5;\n  border: 1px solid #888;\n}\n/*setup*/\n.blurRow {\n  transition: opacity 250ms ease;\n}\n\n/* pfp */\n.pfpBox {\n  transition: all 200ms ease;\n  height: 160px;\n  width: 160px;\n  margin-bottom: 10px;\n  /*background-color: #fbf7f5;*/\n  /*background-color: blue; */\n  border-radius: 10px;\n  overflow: hidden;\n  cursor: pointer;\n  opacity: 0.8;\n}\n.pfpBox:hover {\n  transition: all 200ms ease;\n  margin-top: -3px;\n  opacity: 1;\n}\n\n.pfpFade {\n  animation: 0.6s pfpFadeA ease;\n}\n@keyframes pfpFadeA {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 0.8;\n  }\n}\n\n.blur {\n  filter: blur(4px);\n  opacity: 0.8;\n}\n\n.mainList {\n  display: flex;\n  flex-direction: column;\n  transition: all 200ms ease;\n}\n\n/* add */\ninput.addText::placeholder {\n  color: #fff;\n  opacity: 0.2;\n  margin-right: -3px;\n}\n\ninput.newInput::placeholder {\n  color: #bbb;\n  font-size: 20px;\n}\n\n/* setup */\n.textInput:placeholder {\n  color: #888;\n}\ntextarea:focus,\ninput:focus {\n  outline: none;\n}\n\n.card {\n  background-color: #111;\n  width: 115px;\n  height: 160.7px;\n  border-radius: 6px;\n  border: 1px solid #555;\n  margin-top: -143px;\n  transition: margin-top 0.3s ease; /* Smooth transition for the margin-top change */\n}\n\n.card:first-child {\n  margin-top: 0; /* Ensure the first card doesn't overlap */\n}\n\n.card:hover + .card {\n  margin-top: 0; /* Reset marginTop for the card immediately following a hovered card */\n}\n\n.floppy {\n  transition: all 0.01s ease-in-out;\n  opacity: 0.5;\n}\n.floppy:hover {\n  transition: all 0.01s ease-in-out;\n  opacity: 1;\n}\n\n.plate {\n  line-height: 1;\n  overflow: scroll;\n}\n.plate:focus {\n  outline: none;\n}\n\n.flexCol {\n  display: flex;\n  flex-direction: column;\n}\n.flexRow {\n  display: flex;\n  flex-direction: row;\n}\n.flexCenter {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/*temples*/\n.slideRow {\n}\n\n.decks {\n  display: flex;\n  flex-direction: column-reverse; /* This makes the first item appear at the bottom */\n  align-items: start; /* Align items to the start of the flex-container */\n  overflow-y: auto; /* Allows scrolling when items exceed the container height */\n}\n\n/*chats */\n.raw::-webkit-scrollbar {\n  display: none;\n}\n.rawList::-webkit-scrollbar {\n  display: none;\n}\n.dmChat::-webkit-scrollbar {\n  display: none;\n}\n\n/* fonts */\n.lato300 {\n  font-family: 'Lato', sans-serif;\n  font-weight: 300;\n}\n.lato400 {\n  font-family: 'Lato', sans-serif;\n  font-weight: 400;\n}\n.lato700 {\n  font-family: 'Lato', sans-serif;\n  font-weight: 700;\n}\n.lora500 {\n  font-family: 'Lora', serif;\n  font-weight: 500;\n}\n\n.introButton {\n  border: 1px solid #555;\n  cursor: pointer;\n}\n.introButtonText {\n  border: 1px solid #555;\n}\n\n.introButton:hover {\n  background-color: #3c3c9c;\n  border-color: #3c3c9c;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\n/*inputs */\ninput {\n  box-sizing: border-box;\n  -webkit-appearance: none;\n  appearance: none;\n}\ninput:focus {\n  outline: none; /* remove default outline */\n  border-color: #888; /* or add a custom focus style */\n}\n\n/* button */\nbutton {\n  background: transparent;\n  box-shadow: 0px 0px 0px transparent;\n  border: 0px solid transparent;\n  text-shadow: 0px 0px 0px transparent;\n}\n\nbutton:hover {\n  cursor: pointer;\n  background: transparent;\n  box-shadow: 0px 0px 0px transparent;\n  border: 0px solid transparent;\n  text-shadow: 0px 0px 0px transparent;\n}\n\nbutton:active {\n  outline: none;\n  border: none;\n}\n\nbutton:focus {\n  outline: 0;\n}\n\n.hidden {\n  display: none;\n}\n\n.pointer {\n  cursor: pointer;\n}\n\n.hideScroll {\n  -ms-overflow-style: none; /* Internet Explorer 10+ */\n  scrollbar-width: none; /* Firefox */\n}\n\n.hideScroll::-webkit-scrollbar {\n  display: none; /* Safari and Chrome */\n}\n\n/* Super-thin, gray-on-black scrollbars (still scrollable, barely visible) */\n.thinScroll,\n.thinScroll * {\n  scrollbar-width: thin; /* Firefox */\n  scrollbar-color: #3a3a3a transparent; /* thumb, track */\n}\n\n.thinScroll::-webkit-scrollbar,\n.thinScroll *::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n}\n\n.thinScroll::-webkit-scrollbar-track,\n.thinScroll *::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.thinScroll::-webkit-scrollbar-thumb,\n.thinScroll *::-webkit-scrollbar-thumb {\n  background: #3a3a3a;\n  border-radius: 3px;\n}\n\n.thinScroll::-webkit-scrollbar-thumb:hover,\n.thinScroll *::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n/* Small inline loading spinner (e.g. Import button) */\n@keyframes blogSpin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.blogSpinner {\n  display: inline-block;\n  width: 12px;\n  height: 12px;\n  border: 2px solid rgba(255, 255, 255, 0.4);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: blogSpin 0.6s linear infinite;\n}\n\n/* Reusable light-blue hover for the tier-list/deck buttons (inline-styled, so !important on hover). */\n.blueHover {\n  transition: color 0.18s ease, border-color 0.18s ease;\n}\n.blueHover:hover:not(:disabled) {\n  color: #8fc8ff !important;\n  border-color: #8fc8ff !important;\n}\n\n.noselect {\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Safari */\n  -khtml-user-select: none; /* Konqueror HTML */\n  -moz-user-select: none; /* Old versions of Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none; /* Non-prefixed version, currently\n                                  supported by Chrome, Edge, Opera and Firefox */\n  -webkit-tap-highlight-color: transparent;\n}\n\n/*loader */\n@keyframes rotateA {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes rotateA {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes rotateA {\n  from {\n    -moz-transform: rotate(0deg);\n  }\n  to {\n    -moz-transform: rotate(360deg);\n  }\n}\n@-o-keyframes rotateA {\n  from {\n    -o-transform: rotate(0deg);\n  }\n  to {\n    -o-transform: rotate(180deg);\n  }\n}\n@-ms-keyframes rotateA {\n  from {\n    -ms-transform: rotate(0deg);\n  }\n  to {\n    -ms-transform: rotate(360deg);\n  }\n}\n.arc-hider {\n  margin-left: 6px;\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  border: 2px solid #a6f1df;\n  position: absolute;\n  z-index: 5;\n  clip: rect(0px 18px 18px 0px);\n  -webkit-animation: rotateA 2s linear infinite 0s;\n  -moz-animation: rotateA 2s linear infinite 0s;\n  -o-animation: rotateA 2s linear infinite 0s;\n  -ms-animation: rotateA 2s linear infinite 0s;\n  animation: rotateA 2s linear infinite 0s;\n}\n\n/*colors\n\npastel orange #ff9b1a\n\n*/\n\n/* timer */\n.timer {\n  background-color: #aaa;\n  position: relative;\n}\n\n.bar {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  background-color: #eee;\n  width: 100%;\n  animation: shrink 5s linear backwards;\n}\n\n@keyframes shrink {\n  from {\n    width: 0;\n  }\n  to {\n    width: 100%;\n  }\n}\n\n/* ripples */\n\n.circles {\n  height: 40px;\n  position: relative;\n  width: 40px;\n  margin-left: -2px;\n  margin-top: -2px;\n\n  > div {\n    animation: growAndFade 2s ease-out;\n    border: 1px solid #000;\n    /* background-color: #eee;*/\n    border-radius: 50%;\n    height: 100%;\n    opacity: 0;\n    position: absolute;\n    width: 100%;\n  }\n  .circle1 {\n    animation-delay: 0s;\n  }\n  .circle2 {\n    animation-delay: 0.2s;\n  }\n}\n\n@keyframes growAndFade {\n  0% {\n    opacity: 0.8;\n    transform: scale(0);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(1);\n  }\n}\n\n/* box */\n.rotate45 {\n  transform: rotate(45deg);\n  z-index: 20;\n}\n\n.openDeck {\n  &:hover {\n    background-color: #3c3c9c;\n  }\n}\n\n.deleteX {\n  &:hover {\n    background-color: #3c3c9c;\n  }\n}\n\n/* Hide scrollbar for set-scroll-container */\n.set-scroll-container {\n  scrollbar-width: none; /* Firefox */\n  -ms-overflow-style: none; /* IE 10+ */\n}\n.set-scroll-container::-webkit-scrollbar {\n  display: none; /* Chrome/Safari/Webkit */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
